import { defineComponent as _defineComponent } from 'vue'
import device from '@@/bits/device'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceContributingStatusStore } from '@@/pinia/surface_contributing_status'
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import SurfaceActivitySvg from '@@/vuecomponents/SurfaceActivitySvg.vue'
import AvatarImage from '@@/vuecomponents/avatar_image.vue'
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, onMounted, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceActivityIndicator',
  setup(__props) {

const surfaceStore = useSurfaceStore()
const surfaceDraftsStore = useSurfaceDraftsStore()
const surfaceContributingStatusStore = useSurfaceContributingStatusStore()

const { backgroundColor, backgroundLuminance, isSubmissionRequest } = storeToRefs(surfaceStore)
const { isAnyDraftActive } = storeToRefs(surfaceDraftsStore)
const { activeContributorsList, numberOfAdditionalContributors, xAdditionalContributors, xActivityIndicator } =
  storeToRefs(surfaceContributingStatusStore)
const { clearContributingStatus, updateContributingStatus } = surfaceContributingStatusStore

const isDesktop = device.desktop

watch(isAnyDraftActive, (): void => {
  updateContributingStatus()
})

const clearContributingStatusOnPageClosed = (): void => {
  clearContributingStatus()
}

const clearContributingStatusOnVisibilityChanged = (): void => {
  if (document.visibilityState === 'visible') {
    updateContributingStatus()
  }
  if (document.visibilityState === 'hidden') {
    clearContributingStatus()
  }
}

const clearContributingStatusOnBlur = (): void => {
  clearContributingStatus()
}

const setContributingStatusOnFocus = (): void => {
  updateContributingStatus()
}

onMounted((): void => {
  window.addEventListener('beforeunload', clearContributingStatusOnPageClosed)
  window.addEventListener('blur', clearContributingStatusOnBlur)
  window.addEventListener('focus', setContributingStatusOnFocus)
  window.addEventListener('visibilitychange', clearContributingStatusOnVisibilityChanged)
})

onBeforeUnmount((): void => {
  window.removeEventListener('beforeunload', clearContributingStatusOnPageClosed)
  window.removeEventListener('blur', clearContributingStatusOnBlur)
  window.removeEventListener('focus', setContributingStatusOnFocus)
  window.removeEventListener('visibilitychange', clearContributingStatusOnVisibilityChanged)
})

return { __sfc: true,surfaceStore, surfaceDraftsStore, surfaceContributingStatusStore, backgroundColor, backgroundLuminance, isSubmissionRequest, isAnyDraftActive, activeContributorsList, numberOfAdditionalContributors, xAdditionalContributors, xActivityIndicator, clearContributingStatus, updateContributingStatus, isDesktop, clearContributingStatusOnPageClosed, clearContributingStatusOnVisibilityChanged, clearContributingStatusOnBlur, setContributingStatusOnFocus, SurfaceActivitySvg, AvatarImage }
}

})